import { PageHeader } from "../components/PageHeader";
import { ServiceCard } from "../components/ServiceCard";
import { Card, Lead, P } from "../components/Section";

export default function Bali() {
  return (
    <div className="pb-10">
      <PageHeader
        eyebrow="Недвижимость на Бали"
        title="Три направления"
        subtitle="Выбери, что ближе — инвестиция, аренда для жизни или акционерство в моём отеле."
        icon="🏝"
        iconColor="teal"
      />
      <div className="px-5 mt-3 space-y-3">
        <Card>
          <Lead>
            Я живу на Бали и веду здесь несколько проектов:
            бюро недвижимости RESIDE, управляющую компанию RESIDE Trust и собственный отель Cocoon Resort.
          </Lead>
          <P>
            Знаю рынок изнутри — от застройщиков до управляющих компаний.
          </P>
        </Card>

        <div className="ios-group">
          <ServiceCard to="/bali/villa-rent"
            icon="🏖"
            title="Снять виллу для отдыха / жизни"
            subtitle="Семиньяк, Улувату, Чангу, Убуд"
            color="mint" />
          <ServiceCard to="/bali/cocoon"
            icon="🌿"
            title="Стать акционером Cocoon Resort"
            subtitle="Wellness-отель, средний ROI 19,5%"
            color="brown" />
          <ServiceCard to="/bali/reside"
            icon="💰"
            title="Инвестиции в недвижимость"
            subtitle="RESIDE — 15–20% годовых, 0% комиссия"
            color="teal" />
        </div>
      </div>
    </div>
  );
}
